import { AxiosInstance, AxiosRequestConfig } from 'axios';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export interface HttpClient {
  request<T>(method: HttpMethod, endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
}

export class AxiosHttpClient implements HttpClient {
  constructor(private client: AxiosInstance) {}

  async request<T>(method: HttpMethod, endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.request<T>({
      method,
      url: endpoint,
      data: method !== 'GET' && method !== 'DELETE' ? data : undefined,
      ...config,
    });
    return response.data;
  }
}
